'use strict';

angular.module('ClinicApp').directive('appointmentHistory', function(OCAppointmentUtil, OpencareConstants, AppointmentService) {
  return {
    templateUrl: '/views/directives/_appointment-history.html',
    scope: {
      appointment: '=',
    },
    link: function($scope) {
      $scope.getAvailabilityDisplay = OCAppointmentUtil.getPatientAvailabilityDisplay;
      $scope.availability = OCAppointmentUtil.getPatientAvailabilityDisplay($scope.appointment);
      $scope.reasonForVisit = OCAppointmentUtil.getPatientReasonDisplay($scope.appointment);
      $scope.contactMethods = _.chain($scope.appointment).get('requestData.contactMethods', [])
        .map(function(method) {
          return {
            sms: 'SMS',
            phone: 'Phone',
            email: 'Email',
          }[method];
        })
        .compact()
        .value();

      $scope.photoViewer = {
        photos: [],
        index: 0,
        visible: false,

        open: function(photos, index) {
          $scope.photoViewer.photos = photos || [];
          $scope.photoViewer.index = index || 0;
          $scope.photoViewer.visible = true;
        },

        close: function() {
          $scope.photoViewer.visible = false;
        },
      };

      $scope.insurancePhotoViewer = {
        photos: [],
        index: 0,
        visible: false,
        open: function(photos, index) {
          $scope.insurancePhotoViewer.photos = photos || [];
          $scope.insurancePhotoViewer.index = index || 0;
          $scope.insurancePhotoViewer.visible = true;
        },
        close: function() {
          $scope.insurancePhotoViewer.visible = false;
        },
      };

      /**
       * Returns an array with metadata about specific appointment history item.
       */
      $scope.getHistoryDetails = function(historyItem) {
        var historyDetails;
        if (OCAppointmentUtil.isStatusChangeHistoryItem(historyItem)) {
          if (OCAppointmentUtil.isRescheduledByPatient(historyItem)) {
            return [{
              name: 'Request to Reschedule',
              icon: 'envelope',
              iconColor: 'teal',
              detailsText: historyItem.note || 'Patient has indicated that they are still interested in booking an appointment.',
              rescheduledByPatient: true,
            }];
          } else if (OCAppointmentUtil.isRequested(historyItem.toStatus)) {
            return [{
              name: OCAppointmentUtil.isRescheduled(historyItem.fromStatus) ? 'Resubmitted' : 'Initial Request',
              icon: 'envelope',
              iconColor: 'teal',
              detailsText: 'Request Details',
              timeText: 'Requested Times',
              blocks: historyItem.requestBlocks,
              reservedSlot: historyItem.reservedAppointmentSlot,
              showService: true,
            }];
          } else if (OCAppointmentUtil.isRescheduled(historyItem.toStatus, true)) {
            return [{
              name: 'Sent Response',
              icon: 'calendar',
              iconColor: 'light-yellow',
              detailsText: 'Response Details',
              timeText: 'Responded Time',
              blocks: [historyItem.dateTime],
              showService: true,
            }];
          } else if (OCAppointmentUtil.isScheduled(historyItem.toStatus)) {
            var reservedSlot = historyItem.reservedAppointmentSlot;
            if (reservedSlot) {
              return [{
                name: 'Confirmed',
                icon: 'award-check',
                iconColor: 'blue',
                detailsText: 'Confirmation Details',
                timeText: 'Confirmed Time',
                blocks: [{
                  date: reservedSlot.date,
                  startTime: reservedSlot.time,
                }],
                showService: true,
              }];
            } else {
              return [{
                name: 'Scheduled',
                icon: 'calendar',
                iconColor: 'green',
                detailsText: 'Confirmation Details',
                timeText: 'Scheduled Time',
                blocks: [historyItem.dateTime],
                showService: true,
                showTimeRange: true,
              }];
            }
          } else if (OCAppointmentUtil.isCancelled(historyItem.toStatus)) {
            if (historyItem.actor === OpencareConstants.appointmentHistory.actors.automatic) {
              var name = 'Auto-Cancellation';
              if (_.get($scope.appointment, 'metadata.cancellation.reason.slug') === 'contact') {
                name = 'No Answer ' + name;
              }
              return [{
                name: name,
                icon: 'cancel-circle',
                iconColor: 'red',
                detailsText: 'Cancellation Details',
              }];
            }
            return [{
              name: 'Cancelled By ' + (OCAppointmentUtil.isCancelledByClinic(historyItem.toStatus) ? 'Clinic' : 'Patient'),
              icon: 'cancel-circle',
              iconColor: 'red',
              detailsText: 'Cancellation Details',
            }];
          } else if (OCAppointmentUtil.isArchived(historyItem.toStatus)) {
            return [{
              name: 'Moved to History',
              icon: 'history',
              iconColor: 'grey-d',
              detailsText: 'Time Expired',
            }];
          } else if (OCAppointmentUtil.isVerificationHistoryItem(historyItem)) {
            if (_.get(historyItem, 'metadata.adminVerified', false)) {
              return [{
                name: 'Automatically Verified',
                icon: 'history',
                iconColor: 'grey-d',
                detailsText: 'Approval Details',
                hintText: 'Opencare has automatically verified this appointment based on information the patient has provided.',
              }];
            }

            return [{
              name: 'Verified',
              icon: 'history',
              iconColor: 'grey-d',
              detailsText: 'Approval Details',
            }];
          }
        } else if (OCAppointmentUtil.isRescheduleSlotOptionItem(historyItem)) {
          return [{
            name: 'Message to Patient',
            hideTitle: true,
            icon: 'chat',
            iconColor: 'violet',
            detailsText: 'Staff Notes',
            textColor: 'green',
            textIcon: 'fa-check-circle',
          }];
        } else if (OCAppointmentUtil.isRescheduleSlotOptionResponseItem(historyItem)) {
          return [{
            name: 'Message from Patient',
            hideTitle: true,
            icon: 'chat',
            iconColor: 'violet-inverted',
            textColor: historyItem.dateTime ? 'green' : 'red',
            textIcon: historyItem.dateTime ? 'fa-check-circle' : 'fa-exclamation-triangle',
          }];
        } else if (OCAppointmentUtil.isStaffNoteHistoryItem(historyItem)) {
          return [{
            name: 'Staff Note',
            hideTitle: true,
            icon: 'note',
            iconColor: 'yellow',
            detailsText: 'Staff Notes',
          }];
        } else if (OCAppointmentUtil.isMessageToPatientHistoryItem(historyItem)) {
          return [{
            name: 'Message to Patient',
            hideTitle: true,
            note: _.get(historyItem, 'metadata.message.original') || historyItem.note,
            icon: 'chat',
            iconColor: 'violet',
          }];
        } else if (OCAppointmentUtil.isMessageFromPatientHistoryItem(historyItem)) {
          return [{
            name: 'Message from Patient',
            hideTitle: true,
            icon: 'chat',
            iconColor: 'violet-inverted',
          }];
        } else if (OCAppointmentUtil.isPhoneCallHistoryItem(historyItem)) {
          var patientName = _.capitalize(_.get($scope.appointment, 'patient.firstName', 'the patient'));
          return [{
            name: 'Phone Call',
            hideTitle: false,
            icon: 'phone',
            iconColor: 'violet-inverted',
            detailsText: historyItem.actor == OpencareConstants.appointmentHistory.actors.provider ? ('You called ' + patientName).replace('The patient', 'the patient') : patientName + ' called you',
          }];
        } else if (OCAppointmentUtil.isReconfirmationFlowHistoryItem(historyItem)) {
          var hintText = [
            'Following up with patients to remind them of their upcoming appointments can take a ton of time,',
            'so we’ve automated this process for you!',
            'We will message patients 3 business days in advance of their scheduled appointments to ensure they still plan on attending.',
            'We’ll notify you of their response and what actions you need to take.',
          ].join(' ');

          if (OCAppointmentUtil.isReconfirmationSmsHistoryItem(historyItem)) {
            return [{
              name: 'Automated Attendance Confirmation - 3 business days ahead',
              hideTitle: true,
              icon: 'chore',
              iconNoStroke: true,
              iconColor: 'violet',
              hintText: hintText,
            }];
          } else if (OCAppointmentUtil.isReconfirmationNotSentHistoryItem(historyItem)) {
            return [{
              name: '<b>NOT SENT</b> - Automated Attendance Confirmation',
              hideTitle: true,
              note: 'NOTE: A reconfirmation message was not sent because the appointment is scheduled too soon into the future for it to be necessary.',
              icon: 'chore',
              iconNoStroke: true,
              iconColor: 'violet',
              hintText: hintText,
            }];
          } else if (OCAppointmentUtil.isReconfirmationNoResponseHistoryItem(historyItem)) {
            return [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              dataList: [{
                label: 'Actions required from you:',
                value: 'Reach out to confirm attendance',
              }],
              icon: 'exclamation',
              iconNoStroke: true,
              iconColor: 'yellow',
              hintText: hintText,
            }, {
              name: 'No response from patient',
              hideTitle: true,
              note: 'NOTE: We did not hear back from this patient within 24 hours. We do not know if they are still able to attend their appointment.',
              icon: 'chat-strikethrough',
              iconNoStroke: true,
              iconColor: 'violet-inverted',
            }];
          } else if (OCAppointmentUtil.isReconfirmationLateResponseHistoryItem(historyItem)) {
            historyDetails = [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              icon: 'chore',
              iconNoStroke: true,
              iconColor: 'violet',
              hintText: hintText,
            }];
            if (_.get(historyItem, 'metadata.twilioMessage')) {
              historyDetails.push({
                name: 'Message from Patient',
                hideTitle: true,
                icon: 'chat',
                iconColor: 'violet-inverted',
                note: historyItem.metadata.twilioMessage,
              });
            }
            return historyDetails;
          } else if (OCAppointmentUtil.isReconfirmationPositiveResponseHistoryItem(historyItem)) {
            historyDetails = [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              dataList: [{
                label: 'Patient status updated to:',
                value: 'Confirmed',
              }, {
                label: 'Actions required from you:',
                value: 'None',
              }],
              icon: 'check',
              iconNoStroke: true,
              iconColor: 'green',
              hintText: hintText,
            }];
            if (_.get(historyItem, 'metadata.twilioMessage')) {
              historyDetails.push({
                name: 'Message from Patient',
                hideTitle: true,
                icon: 'chat',
                iconColor: 'violet-inverted',
                note: historyItem.metadata.twilioMessage,
              });
            }
            return historyDetails;
          } else if (OCAppointmentUtil.isReconfirmationNegativeResponseHistoryItem(historyItem)) {
            if (_.get(historyItem, 'metadata.twilioMessage')) {
              // New reconfirmation flow presentation.
              return [{
                name: 'Automated Attendance Confirmation',
                hideTitle: true,
                icon: 'chore',
                iconNoStroke: true,
                iconColor: 'violet',
                hintText: hintText,
              }, {
                name: 'Message from Patient',
                hideTitle: true,
                icon: 'chat',
                iconColor: 'violet-inverted',
                note: historyItem.metadata.twilioMessage,
              }];
            } else {
              // Old reconfirmation flow presentation.
              return [{
                name: 'Automated Attendance Confirmation',
                hideTitle: true,
                icon: 'times',
                iconNoStroke: true,
                iconColor: 'red',
                hintText: hintText,
              }];
            }
          } else if (OCAppointmentUtil.isReconfirmationNegativeResponseFollowupRescheduleHistoryItem(historyItem)) {
            historyDetails = [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              dataList: [{
                label: 'Patient status updated to:',
                value: 'Requested',
              }, {
                label: 'Actions required from you:',
                value: 'Reach out to reschedule this patient',
              }],
              icon: 'retry',
              iconNoStroke: true,
              iconColor: 'teal',
              hintText: hintText,
            }];
            if (_.get(historyItem, 'metadata.twilioMessage')) {
              historyDetails.push({
                name: 'Message from Patient',
                hideTitle: true,
                icon: 'chat',
                iconColor: 'violet-inverted',
                note: historyItem.metadata.twilioMessage,
              });
            }
            return historyDetails;
          } else if (OCAppointmentUtil.isReconfirmationNegativeResponseFollowupCancelHistoryItem(historyItem)) {
            historyDetails = [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              icon: 'chore',
              iconNoStroke: true,
              iconColor: 'violet',
              hintText: hintText,
            }, {
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              dataList: [{
                label: 'Patient status updated to:',
                value: 'Cancelled',
              }, {
                label: 'Action required from you:',
                value: 'Remove appointment from your schedule',
              }],
              icon: 'times',
              iconNoStroke: true,
              iconColor: 'red',
              hintText: hintText,
            }];
            if (_.get(historyItem, 'metadata.twilioMessage')) {
              historyDetails.push({
                name: 'Message from Patient',
                hideTitle: true,
                icon: 'chat',
                iconColor: 'violet-inverted',
                note: historyItem.metadata.twilioMessage,
              });
            }
            return historyDetails;
          } else if (OCAppointmentUtil.isReconfirmationNegativeResponseAutoRescheduleHistoryItem(historyItem)) {
            return [{
              name: 'Automated Attendance Confirmation',
              hideTitle: true,
              dataList: [{
                label: 'Patient status updated to:',
                value: 'Requested',
              }, {
                label: 'Actions required from you:',
                value: 'Reach out to reschedule this patient',
              }],
              icon: 'retry',
              iconNoStroke: true,
              iconColor: 'teal',
              hintText: hintText,
            }, {
              name: 'No response from patient',
              hideTitle: true,
              note: 'NOTE: We did not hear back from this patient within 15 minutes. We do not know if they would like to reschedule their appointment.',
              icon: 'chat-strikethrough',
              iconNoStroke: true,
              iconColor: 'violet-inverted',
            }];
          }
        } else if (OCAppointmentUtil.isOffHoursSmsHistoryItem(historyItem)) {
          return [{
            name: 'Off-Hours Auto-Response',
            hideTitle: true,
            icon: 'envelope',
            iconColor: 'violet',
            hintText: 'Patients love to hear from their chosen provider soon after they submit a request on Opencare. When your practice is closed and you’re unable to respond,  we’ll send a personalized confirmation message on your behalf to welcome them to your practice and begin the conversation.',
          }];
        } else if (OCAppointmentUtil.isAutoCancellationSmsHistoryItem(historyItem)) {
          return [{
            name: '48-hour No Answer Auto-Response',
            hideTitle: true,
            icon: 'envelope',
            iconColor: 'violet',
            hintText: "To reduce the time you need to spend following up with patient, we've automated it for you. If the patient hasn't responded in 48 hours from your last message or call, we will let the patient know their appointment may be automatically cancelled.",
          }];
        } else if (OCAppointmentUtil.isNprDripSmsHistoryItem(historyItem)) {
          return [{
            name: 'Follow-up Auto-Response',
            hideTitle: true,
            icon: 'envelope',
            iconColor: 'violet',
            hintText: "Patients sometimes need a little extra nudge to remind them to respond to messages. After you first reach out to a patient, we'll send them a message on your behalf at noon the next day. We'll send two more messages after that. If you call the patient, send them a message or if they reply, we will hold off sending this message.",
          }];
        }
      };
      $scope.getHistoryIconUrl = function(historyDetails) {
        return _.get(historyDetails, 'icon') ? '/img/icons/' + historyDetails.icon + '.svg' : '';
      };

      AppointmentService.getSlotWorks($scope.appointment.id).then(function(response) {
        $scope.responded = response.responded;
        $scope.slotWorks = response.slotWorks;
        $scope.respondedAt = moment(response.respondedAt).format('MMMM Do YYYY, h:mm a');
      });
    },
  };
});
